<template>
  <div
    @click="setModification"
    class="food-card-component d-flex align-center justify-space-between"
    :class="{ checked }"
  >
    <div class="food-info-section">
      <span class="food-name font-weight-bold">{{ item.menuItem.name }}</span>
      <span class="d-block modification-info">
        Модификатор:
        <span class="font-weight-medium">{{
          item.menuItem.modifications[0].modification.name
        }}</span>
      </span>
      <span v-if="item.comment" class="modification-info">
        Комментарий:
        <span class="font-weight-medium">{{ item.comment }}</span>
      </span>
    </div>
    <div class="price-section d-flex align-start">
      <div v-if="checked" class="checked">
        <font-awesome-icon icon="check" />
      </div>
      <span class="price font-weight-medium">{{ getPrice | amountWithCurrency }}</span>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinsSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'FoodCard',
    mixins: [mixinsSnackbarMessage],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      checked () {
        return !!this.item.modificationMenuItem
      },
      getPrice () {
        return this.item.menuItem.modifications[0].actualPrice - this.item.menuItem.price
      },
    },
    methods: {
      setModification () {
        const id = this.item.id
        const data = {
          menuItemId: this.item.menuItem.id,
        }

        if (!this.item.modificationMenuItem) {
          data.modificationId = this.item.menuItem.modifications[0].id
        } else {
          data.modificationId = null
        }

        this.$store
          .dispatch('baskets/updateBasketItem', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.dispatch('baskets/fetchSingleBasket', this.basket.id)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less" scoped>
.food-card-component {
  margin-bottom: 15px;
  padding: 24px 25px 22px 21px;
  background-color: @color-secondary;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;

  &.checked {
    background-color: @color-primary;
    .food-name,
    .price,
    .modification-info {
      color: #ffffff;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  .food-info-section {
    flex: 1;

    .food-name {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 6px;
    }

    .price-info {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .price-section {
    height: 50px;

    .checked {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      background-color: #ffffff;
      margin-right: 36px;

      svg {
        width: 18px;
        height: 18px;
        .fill-svg(@color-primary);
      }
    }

    .price {
      font-size: 28px;
      line-height: 1;
    }

    .button-edit {
      height: 50px;
      width: 50px;
      background-color: #d4ddeb !important;

      svg {
        width: 18px;
        height: 18px;
        .fill-svg(@color-secondary);
      }

      ::v-deep {
        .v-btn__content {
          text-align: center;
        }
      }
    }
  }
}
</style>
